/* BuzzlyHQ theme JS - shared interactions */
(function () {
  'use strict';

  // FAQ accordion
  function initAccordions() {
    document.querySelectorAll('.faq-q, .accord-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item, .accord-item');
        if (!item) return;
        item.classList.toggle('open');
      });
    });
  }

  // Animated counters
  function initCounters() {
    var stats = document.querySelectorAll('[data-counter]');
    if (!stats.length || !('IntersectionObserver' in window)) {
      stats.forEach(function (el) { el.textContent = el.dataset.counter; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.dataset.counter);
        var dur = 1600;
        var start = performance.now();
        function tick(now) {
          var t = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - t, 3);
          var val = target * eased;
          var formatted;
          if (target >= 1000) formatted = Math.round(val).toLocaleString();
          else if (target % 1 !== 0) formatted = val.toFixed(1);
          else formatted = Math.round(val).toString();
          el.textContent = formatted;
          if (t < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    stats.forEach(function (el) { io.observe(el); });
  }

  // Tier selector on product page
  function initTierSelector() {
    var tiers = document.querySelectorAll('[data-tier]');
    if (!tiers.length) return;
    var priceEl = document.querySelector('[data-price-display]');
    var selectedLabel = document.querySelector('[data-tier-selected]');
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (priceEl) priceEl.textContent = t.dataset.price;
        if (selectedLabel) selectedLabel.textContent = t.dataset.label;
      });
    });
  }

  // Quantity stepper
  function initQtyStepper() {
    document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
      var input = stepper.querySelector('input');
      var minus = stepper.querySelector('[data-qty="-"]');
      var plus = stepper.querySelector('[data-qty="+"]');
      if (!input) return;
      minus && minus.addEventListener('click', function () {
        var v = Math.max(1, parseInt(input.value || '1', 10) - 1);
        input.value = v;
      });
      plus && plus.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10) + 1;
        input.value = v;
      });
    });
  }

  // Collection filter chips (client-side static demo)
  function initChips() {
    var chips = document.querySelectorAll('[data-filter]');
    if (!chips.length) return;
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('active'); });
        chip.classList.add('active');
        var f = chip.dataset.filter;
        document.querySelectorAll('[data-cat]').forEach(function (card) {
          if (f === 'all' || card.dataset.cat === f) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  // Service-jump scroll-spy on platform sub-pages
  function initServiceJump() {
    var jumpLinks = document.querySelectorAll('.service-jump a[href^="#"]');
    if (!jumpLinks.length) return;
    var sections = [];
    jumpLinks.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      var s = document.getElementById(id);
      if (s) sections.push({ link: a, section: s });
    });
    function onScroll() {
      var scrollY = window.scrollY + 180;
      var current = null;
      sections.forEach(function (s) {
        if (s.section.offsetTop <= scrollY) current = s;
      });
      jumpLinks.forEach(function (a) { a.classList.remove('is-active'); });
      if (current) current.link.classList.add('is-active');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Pricing-card cart action (preview demo)
  function initPricingCards() {
    document.querySelectorAll('[data-pricing-cta]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var label = btn.dataset.label || 'item';
        var price = btn.dataset.price || '';
        // Pulse + temporary label change
        var orig = btn.innerHTML;
        btn.innerHTML = '<span>Added ✓</span><span>' + price + '</span>';
        btn.style.background = 'var(--success)';
        btn.style.color = 'white';
        setTimeout(function () {
          btn.innerHTML = orig;
          btn.style.background = '';
          btn.style.color = '';
        }, 1600);
        // Bump the cart count visually
        var count = document.querySelector('.cart-count');
        if (count) {
          var n = parseInt(count.textContent || '0', 10) + 1;
          count.textContent = n;
          count.animate(
            [{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }],
            { duration: 360, easing: 'cubic-bezier(.2,.8,.2,1)' }
          );
        }
      });
    });
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  function boot() {
    initAccordions();
    initCounters();
    initTierSelector();
    initQtyStepper();
    initChips();
    initServiceJump();
    initPricingCards();
  }
})();
